import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=24160b1e&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24160b1e')) {
      api.createRecord('24160b1e', component.options)
    } else {
      api.reload('24160b1e', component.options)
    }
    module.hot.accept("./NotificationCenter.vue?vue&type=template&id=24160b1e&", function () {
      api.rerender('24160b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/NotificationCenter.vue"
export default component.exports